// @ts-check
import { Bar, BarChart, Cell, XAxis, YAxis } from 'recharts';
import BlockCard from '../BlockCard';

// Order and labels follow the backend enums (OutreachStatus, ScheduledPostStatus). The admin build cannot import /shared.
const STAGES = [
  ['reached_out', 'Reached out', '#94a3b8'],
  ['in_conversation', 'Talking', '#3b82f6'],
  ['agreement_signed', 'Signed', '#8b5cf6'],
  ['collaborated', 'Done', '#22c55e'],
  ['inactive', 'Inactive', '#ef4444'],
];
const POSTS = [
  ['draft', 'Draft', '#94a3b8'],
  ['scheduled', 'Scheduled', '#3b82f6'],
  ['published', 'Published', '#22c55e'],
  ['failed', 'Failed', '#ef4444'],
];

function Group({ id, title, defs, counts, empty }) {
  const bars = defs.map(([key, name, fill]) => ({ name, fill, value: counts[key] || 0 }));
  return (
    <div className="mt-2 first:mt-0">
      <p className="text-xs text-muted-foreground">{title}</p>
      {bars.some((b) => b.value > 0) ? (
        <div data-testid={id} className="overflow-x-auto">
          <BarChart width={260} height={90} data={bars} aria-hidden="true">
            <XAxis dataKey="name" tickLine={false} axisLine={false} fontSize={10} />
            <YAxis hide allowDecimals={false} />
            <Bar dataKey="value" isAnimationActive={false}>
              {bars.map((b) => (
                <Cell key={b.name} fill={b.fill} />
              ))}
            </Bar>
          </BarChart>
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">{empty}</p>
      )}
    </div>
  );
}

/** Comment drafts awaiting posting (headline) with influencer and post pipelines as two labelled bar groups for context. */
export default function MarketingBlock({ block }) {
  const { influencers_by_stage: stages = {}, posts_by_status: posts = {} } = block.data || {};
  return (
    <BlockCard title="Marketing" href={block.href} headline={block.headline}>
      <Group id="marketing-influencers" title="Influencers by stage" defs={STAGES} counts={stages} empty="No influencers yet" />
      <Group id="marketing-posts" title="Posts by status" defs={POSTS} counts={posts} empty="No posts yet" />
    </BlockCard>
  );
}
